import { Link } from "react-router-dom";
import HoSoDong from "../components/HoSoDong.jsx";
import TheViecLuoi from "../components/TheViecLuoi.jsx";
import SoLieuNhanh from "../components/SoLieuNhanh.jsx";
import { SO_TRAM } from "../data/lo-trinh.js";
import { TheHanhTrinh, urlCongCu } from "./Home.jsx";
import { track } from "../lib/track.js";

/**
 * /bat-dau — trang gọn để chia sẻ (Zalo, Facebook, tin nhắn).
 *
 * Người mở link thấy ngay: một câu tiêu đề, khung động "câu hỏi → hồ sơ", và
 * MỘT việc cần làm. Trên điện thoại nút đó dính ở đáy màn hình. Bên dưới có
 * bốn thẻ việc cho ai muốn xem thêm, rồi link về trang chủ đầy đủ.
 *
 * Không lập chỉ mục (noindex, canonical về "/") vì nội dung trùng trang chủ.
 */
const NUT = { to: urlCongCu("readiness-score"), nhan: "Chấm mức sẵn sàng gọi vốn" };
const bam = (noi) => () => track("bat_dau_bam", { noi });

export default function BatDau() {
  return (
    <>
      <section className="bat-dau" aria-labelledby="bat-dau-tieu-de">
        <div>
          <p className="eyebrow">DÀNH CHO NGƯỜI GỌI VỐN LẦN ĐẦU</p>
          <h1 id="bat-dau-tieu-de">
            Gọi vốn lần đầu? <span>Bắt đầu từ đây.</span>
          </h1>
          <p className="lead">
            Mỗi câu hỏi nhà đầu tư sẽ hỏi là một phần của hồ sơ. Trả lời đủ, bạn có
            bộ hồ sơ gửi quỹ được. Miễn phí, không cần tài khoản.
          </p>
          <div className="bat-dau-nut">
            <Link className="nut" to={NUT.to} onClick={bam("chinh")}>{NUT.nhan} <small>· 3 phút</small> →</Link>
            <Link to="/lo-trinh">Xem lộ trình {SO_TRAM} trạm →</Link>
          </div>
        </div>
        <HoSoDong cta={{ to: NUT.to, nhan: "Bắt đầu hồ sơ của bạn" }} />
        <SoLieuNhanh className="bat-dau-so" />
      </section>

      <section className="bat-dau-them" aria-labelledby="bat-dau-them">
        <h2 id="bat-dau-them">Hoặc chọn việc bạn cần giải quyết</h2>
        <TheViecLuoi renderThe={(j) => <TheHanhTrinh j={j} key={j.id} />} />
        <p className="section-space"><Link to="/">Xem trang chủ đầy đủ →</Link></p>
      </section>

      <div className="bat-dau-dinh">
        <Link className="nut" to={NUT.to} onClick={bam("dinh")}>{NUT.nhan} · 3 phút →</Link>
      </div>
    </>
  );
}
